import { useParams } from 'react-router-dom';
import { useQuery, useMutation, useQueryClient, QueryClient, QueryClientProvider } from '@tanstack/react-query';

import League from './League';
import { api } from '../../AppConfig';

function RoutedLeague() {
  // Access the client
  const queryClient = useQueryClient();

  const { id } = useParams();
  // console.warn('che id mi viene passato?', id);

  //otherwise we fetch the data and pass to the display component
  const leagueQuery = useQuery({ 
    queryKey: ['league'],
    staleTime: 0,
    cacheTime: 0,
    queryFn: () => 
      fetch(api.leagues().detailsById(id).href).then((res) =>
        res.json(), 
      )
  })
  const leagueSeasonsQuery = useQuery({ 
    queryKey: ['leagueSeasons'], 
    queryFn: () => 
      fetch(api.leagues().getSeasons(id).href).then((res) =>
        res.json(), 
      )
  })

  const leagueEventsQuery = useQuery({ 
    queryKey: ['leagueEvents'], 
    queryFn: () => 
      fetch(api.leagues().getEvents(id).href).then((res) =>
        res.json(), 
      )
  })

  if (!id) return (<div></div>);

  return <League id={id} league={leagueQuery} seasons={leagueSeasonsQuery} events={leagueEventsQuery} />;
}

export default RoutedLeague;